import { Badge } from "ui/components/badge";

export const SkillCell = ({ row }) => {
    const skills = row.original?.skills || [];
    
    if (!skills || skills.length === 0) {
        return <span className="text-muted-foreground">-</span>;
    }

    return (
        <div className="flex flex-wrap gap-1 items-center">
            {skills.map((item, index) => {
                const skillName = item?.skill?.name;
                if (!skillName) return null;
                return (
                    <Badge key={item?.skill?.id || index} variant="outline" className="font-normal whitespace-nowrap">
                        {skillName}
                    </Badge>
                );
            })}
        </div>
    );
};
